import React from "react";
import headSectionImage from "./@Images/headSectionImage.svg";
import {BottomSectionComponent, HeadSectionComponent} from "../../Parts/Sections";
import SectionContainerComponent from "@Components/Sections/SectionContainer";
import BadgeCardComponent from "@Components/Elements/Cards/BadgeType";
import securityIcon from "@Icons/SVG/icon-security-xl-white.svg";
import arrowRightIcon from "@Icons/SVG/icon-arrow_right-l-yellow.svg";
import pinDropIcon from "@Icons/SVG/icon-pin_drop-l-yellow.svg";
import phoneIcon from "@Icons/SVG/icon-phone-l-yellow.svg";
import accessTimeIcon from "@Icons/SVG/icon-access_time-l-yellow.svg";
import "./index.scss";
import ContactUsPageContactForm from "@Pages/ContactUs/ContactForm";
import {Col, Row} from "react-bootstrap";
import {ReactSVG} from "react-svg";
import {ExplanationListElementComponent} from "../../Parts/Elements";
import iconMessage from "@Icons/SVG/icon-message.svg";
import {ButtonComponent} from "@Components/Forms";

import iconMailL from "@Icons/SVG/icon-mail-l-white.svg";
import iconSecurityL from "@Icons/SVG/icon-security-l-white.svg";
import iconLegalL from "@Icons/SVG/icon-legal-l-white.svg";
import {PageContainerComponent} from "@Components/Sections";
import ContactUsPageContactCategories from "@Pages/ContactUs/ContactCategories";


export const ContactUsPage:React.FC = () => {


    return (
        <PageContainerComponent pageType={'contact-us-page'}>

            <HeadSectionComponent
                pageName={'contact-us'}
                sectionHeaderText={'Get In Touch'}
                sectionSubText={'Questions about Qyvo? Need support? Want to partner with us? We\'re here to help and would love to hear from you.'}
                sectionImage={headSectionImage}
            />

            <ContactUsPageContactCategories />

            <ContactUsPageContactForm />

            <SectionContainerComponent id={'contact-us-page__contact-data-section'}>

                <Col xs={12} xl={4} className={'contact-us-page__contact-data-section__contact-data'}>
                    <Row className={'contact-us-page__contact-data-section__contact-data__content'}>
                        <Col xs={12} className={'data-elements-list__list-header'}>
                            <span>Our office</span>
                        </Col>
                        <Col xs={12} className={'data-elements-list__data-element'}>
                            <span className={'data-elements-list__data-element__element-icon'}>
                                <ReactSVG src={pinDropIcon} wrapper={'span'} />
                            </span>
                            <span className={'data-elements-list__data-element__element-text'}>
                                Qyvo P.S.A<br/>
                                Leśna 1, 81-854<br/>
                                Sopot, Poland<br/>
                            </span>
                        </Col>
                        {/*<Col xs={12} className={'data-elements-list__data-element'}>*/}
                        {/*    <span className={'data-elements-list__data-element__element-icon'}>*/}
                        {/*        <ReactSVG src={phoneIcon} wrapper={'span'} />*/}
                        {/*    </span>*/}
                        {/*    <span className={'data-elements-list__data-element__element-text'}>*/}
                        {/*        +353 1 234 5678*/}
                        {/*    </span>*/}
                        {/*</Col>*/}
                        {/*<Col xs={12} className={'data-elements-list__data-element'}>*/}
                        {/*    <span className={'data-elements-list__data-element__element-icon'}>*/}
                        {/*        <ReactSVG src={accessTimeIcon} wrapper={'span'} />*/}
                        {/*    </span>*/}
                        {/*    <span className={'data-elements-list__data-element__element-text'}>*/}
                        {/*        Monday - Friday, 9:00 AM - 6:00 PM GMT*/}
                        {/*    </span>*/}
                        {/*</Col>*/}
                    </Row>
                </Col>

                <Col xs={12} xl={8} className={'contact-us-page__contact-data-section__information-data'}>
                    <Row className={'contact-us-page__contact-data-section__information-data__content'}>
                        <Col xs={12} className={'data-elements-list__list-header'}>
                            <span>Contact Us</span>
                        </Col>
                        <Col xs={12} xl={5} className={'data-elements-list__data-element'}>
                            <span className={'data-elements-list__data-element__element-icon'}>
                                <ReactSVG src={arrowRightIcon} wrapper={'span'} />
                            </span>
                            <span className={'data-elements-list__data-element__element-text'}>
                                <strong>General Inquiries</strong>
                                <a href={'mailto:hello@useqyvo.com'}>hello@useqyvo.com</a>
                            </span>
                        </Col>
                        <Col xs={12} xl={5} className={'data-elements-list__data-element'}>
                            <span className={'data-elements-list__data-element__element-icon'}>
                                <ReactSVG src={arrowRightIcon} wrapper={'span'} />
                            </span>
                            <span className={'data-elements-list__data-element__element-text'}>
                                <strong>Technical Support</strong>
                                <a href={'mailto:support@useqyvo.com'}>support@useqyvo.com </a>
                            </span>
                        </Col>
                        <Col xs={12} xl={5} className={'data-elements-list__data-element'}>
                            <span className={'data-elements-list__data-element__element-icon'}>
                                <ReactSVG src={arrowRightIcon} wrapper={'span'} />
                            </span>
                            <span className={'data-elements-list__data-element__element-text'}>
                                <strong>Privacy & Legal</strong>
                                <a href={'mailto:privacy@useqyvo.com'}>privacy@useqyvo.com</a>
                            </span>
                        </Col>
                        <Col xs={12} xl={5} className={'data-elements-list__data-element'}>
                            <span className={'data-elements-list__data-element__element-icon'}>
                                <ReactSVG src={arrowRightIcon} wrapper={'span'} />
                            </span>
                            <span className={'data-elements-list__data-element__element-text'}>
                                <strong>Press & Media</strong>
                                <a href={'mailto:press@useqyvo.com'}>press@useqyvo.com</a>
                            </span>
                        </Col>
                    </Row>
                </Col>

            </SectionContainerComponent>

            <BottomSectionComponent
                sectionName={'contact-us-page'}
                sectionHeaderText={'Quick Answers'}
                sectionSubText={'Common questions before you reach out'}
            >

                <ExplanationListElementComponent
                    elementTitle={'How quickly can I expect a response?'}
                    elementContent={'We aim to respond to all inquiries within 24 hours during business days.'}
                    elementIcon={iconMessage}
                    xl={10}
                />

                <ExplanationListElementComponent
                    elementTitle={'Do you offer phone support?'}
                    elementContent={'Currently, we provide support primarily through email. For urgent matters, please mark your email as "URGENT" in the subject line.'}
                    elementIcon={iconMessage}
                    xl={10}
                />

                <ExplanationListElementComponent
                    elementTitle={'Can I schedule a demo or call?'}
                    elementContent={'Yes! For partnership inquiries or press requests, we\'re happy to schedule a call. Please mention this in your message.'}
                    elementIcon={iconMessage}
                    xl={10}
                />

                <Col xs={12} className={'contact-us-page__page-bottom-section__cta-button'}>
                    <ButtonComponent
                        text={'View Full FAQ →'}
                        type={'cta'}
                        size={'l'}
                        href={'/faq'}
                    />
                </Col>

            </BottomSectionComponent>

        </PageContainerComponent>
    );

};


export default ContactUsPage;
